<table class="table value-table pair-table">
    <thead>
        <tr>
            <th>{{'diplomaSupplement_lblNr' | translate}}</th>
            <th>{{'diplomaSupplement_lblLv' | translate}}</th>
            <th>{{'diplomaSupplement_lblEn' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let p of items">
            <td>{{p.index}}</td>
            <td *ngFor="let n of toArray(p)">
                <label [class.required]="n.edit?.required">{{translate(p.label, 'lv')}}</label>

                <div *ngIf="n.edit" class="mt-1">
                    <app-diploma-supplement-value-input [props]="n.edit"
                                                        (valueChange)="n.edit.onChange($event)"></app-diploma-supplement-value-input>

                    <div *ngIf="n.next !== undefined" class="value-wrapper mt-1">
                        <div [innerHTML]="n.value || '' | safeHtml"
                             class="value-prev"
                             *ngIf="n.next != n.value"></div>

                        <div [innerHTML]="n.next | safeHtml"
                             class="value-next"
                             *ngIf="n.next != n.value"></div>
                    </div>
                </div>

                <div *ngIf="!n.edit" class="value-wrapper">
                    <div [innerHTML]="isEmpty(n.value) ? translate('diplomaSupplement_noData', 'lv') : n.value | safeHtml"
                         [class.value-empty]="isEmpty(n.value)"
                         [class.value-prev]="n.next !== undefined && n.next != n.value"></div>

                    <div [innerHTML]="isEmpty(n.next) ? translate('diplomaSupplement_noData', 'en') : n.next | safeHtml"
                         class="value-next"
                         [class.value-empty]="isEmpty(n.next)"
                         *ngIf="n.next !== undefined && n.next != n.value"></div>
                </div>
            </td>
        </tr>
    </tbody>
</table>

